import mapSelectedStateToProps from './mapSelectedStateToProps';
import mapSelectedDispatchToProps from './mapSelectedDispatchToProps';
import mapSelectedSelectorsToProps from './mapSelectedSelectorsToProps';
import { connect } from 'react-redux';
/**
 * Decorates component with required state in props
 * Requred options format:
 * — `object { [string propName]: array pathToState }`
 * — function returning data in the same format
 *
 * @param  {Object} options - options
 * @return {Object} - react component with connected state
 */

export function connectState(options) {
  var props = mapSelectedStateToProps(options);
  return connect(props, null);
}
/**
 * Creates a function with binded application selectors
 *
 * @param  {Object} appSelectors - application selectors
 * @return {Function} - connect selectors decorator
 */

export function createConnectSelectors(appSelectors) {
  /**
   * Decorates component with required selectors as props
   *
   * @param  {Object} options - options
   * @return {Object} - react component with connected selectors
   */
  return function connectSelectors(options) {
    var props = mapSelectedSelectorsToProps(options, appSelectors);
    return connect(props, null);
  };
}
/**
 * Creates a function with binded application actions
 *
 * @param  {Object} appActions - application action creators
 * @return {Function} - connect actions decorator
 */

export function createConnectActions(appActions) {
  /**
   * Decorates component with required action creators as props
   * Requred options format:
   * — `object { [string propName]: array pathToActionCreator }`
   * — function returning data in the same format
   *
   * @param  {Object} options - options
   * @return {Object} - react component with connected action creators
   */
  return function connectActions(options) {
    var actions = mapSelectedDispatchToProps(options, appActions);
    return connect(null, actions);
  };
}